<template>
  <div
    class="c-table-actions"
    :class="{
      'c-table-actions__red': shouldCellBeRed,
      'c-table-actions__blue': shouldCellBeBlue,
    }"
  >
    <m-confirm ref="confirm" mode="danger" />
    <edit-violation-modal ref="editModal" />

    <div class="c-table-actions__wrapper">
      <div class="c-table-actions__action">
        <svg
          v-if="record.doesRequireExplanatory && record.explanatory.entity"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Просмотр объяснительной',
            placement: 'bottom',
          }"
          width="13"
          height="15"
          viewBox="0 0 13 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="viewExplanatory"
        >
          <path d="M12 6V14H1V1H7M12 6H7V1M12 6L7 1" stroke="#8E9CBB" stroke-width="2" stroke-linejoin="round" />
        </svg>
        <svg
          v-if="record.doesRequireExplanatory && !record.explanatory.entity"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Написать объяснительную',
            placement: 'bottom',
          }"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="addExplanatory"
        >
          <path
            d="M14 1L14.9439 1.33035C15.0708 0.967765 14.9788 0.564532 14.7071 0.292894C14.4355 0.0212557 14.0323 -0.0707638 13.6697 0.0561414L14 1ZM9.45 14L8.53619 14.4061C8.70271 14.7808 9.08108 15.0159 9.49076 14.9992C9.90044 14.9825 10.2584 14.7174 10.3939 14.3304L9.45 14ZM1 5.55L0.66965 4.60614C0.282649 4.74159 0.0175448 5.09956 0.000831127 5.50924C-0.0158825 5.91892 0.219182 6.29729 0.593863 6.46381L1 5.55ZM13.0562 0.669648L8.50614 13.6696L10.3939 14.3304L14.9439 1.33035L13.0562 0.669648ZM10.3638 13.5939L7.76384 7.74387L5.93621 8.55614L8.53619 14.4061L10.3638 13.5939ZM7.25616 7.23619L1.40614 4.63619L0.593863 6.46381L6.44389 9.06381L7.25616 7.23619ZM1.33035 6.49386L14.3304 1.94386L13.6697 0.0561414L0.66965 4.60614L1.33035 6.49386ZM13.2929 0.292893L6.14292 7.44289L7.55713 8.85711L14.7071 1.70711L13.2929 0.292893Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>
      <div class="c-table-actions__action violation-edit-action">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Редактировать',
            placement: 'bottom',
          }"
          icon="edit"
          size="iconic"
          @click="editViolation"
        />
      </div>
      <div class="c-table-actions__action">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: 'Удалить',
            placement: 'bottom',
          }"
          :icon="{ icon: 'trash', color: 'secondary' }"
          size="iconic"
          @click="deleteViolation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Confirm from "@/components/modals/confirm-modal";
import EditViolationModal from "@/pages/violations/edit-violation-modal";

export default {
  name: "actions-cell",
  components: {
    "c-button": Button,
    "m-confirm": Confirm,
    EditViolationModal,
  },
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    shouldCellBeRed() {
      if ("doesRequireExplanatory" in this.record) {
        return this.record.doesRequireExplanatory && !this.record.explanatory.entity;
      }
      return false;
    },
    shouldCellBeBlue() {
      if ("explanatory" in this.record) {
        const { entity, isReviewed } = this.record.explanatory;
        return entity && !isReviewed;
      }
      return false;
    },
  },
  methods: {
    editViolation() {
      this.$refs.editModal.open(this.record);
    },
    deleteViolation() {
      this.$refs.confirm.open({
        title: "Удаление нарушения",
        text: `Для сотрудника <b>${this.record.fio.value}</b> будет удалено нарушение <b>${this.record.foul.value}</b> без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("violations/deleteViolation", this.record.id);
        },
      });
    },
    addExplanatory() {
      this.$emit("addExplanatory", this.record);
    },
    viewExplanatory() {
      this.$emit("viewExplanatory", this.record);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table-actions {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &__red {
    background-color: #ffe6f2;
  }
  &__blue {
    background-color: #e1edff;
  }
  &__wrapper {
    display: flex;
    padding: 18px 12px;
  }
  &__action {
    width: 16px;
    cursor: pointer;
    &.violation-edit-action {
      margin: 2px 14px 0 14px;
    }
  }
}
</style>
